export function handleXssInput(value, isPassword = false) {
  if (value) {
    return isPassword
      ? value.replace(/\</g, '').replace(/\>/g, '').replace(/\"/g, '').replace(/\//g, '')
      : value.replace(/\&/g, '').replace(/\</g, '').replace(/\>/g, '').replace(/\"/g, '').replace(/\//g, '')
  }

  return value
}
